// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Improve mobile touch targets */
  touch-action: manipulation;
}

/* Global mobile-friendly styles */
* {
  box-sizing: border-box;
}

/* Improve button and input touch targets on mobile */
@media (max-width: 768px) {
  button {
    min-height: 44px;
    min-width: 44px;
  }
  
  input, 
  select, 
  textarea {
    min-height: 44px;
    font-size: 16px; /* Prevents zoom on iOS */
  }
  
  /* Make tables horizontally scrollable on mobile */
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  
  /* Better spacing for mobile */
  .filter-controls {
    padding: 15px !important;
  }
  
  .filter-row {
    flex-direction: column !important;
    gap: 10px !important;
  }
  
  .filter-group {
    width: 100% !important;
    min-width: auto !important;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,eAAe,EAAE,yBAAyB;EAC5C;;EAEA,kDAAkD;EAClD;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE;aACW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Improve mobile touch targets */\n  touch-action: manipulation;\n}\n\n/* Global mobile-friendly styles */\n* {\n  box-sizing: border-box;\n}\n\n/* Improve button and input touch targets on mobile */\n@media (max-width: 768px) {\n  button {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  input, \n  select, \n  textarea {\n    min-height: 44px;\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n  \n  /* Make tables horizontally scrollable on mobile */\n  table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  \n  /* Better spacing for mobile */\n  .filter-controls {\n    padding: 15px !important;\n  }\n  \n  .filter-row {\n    flex-direction: column !important;\n    gap: 10px !important;\n  }\n  \n  .filter-group {\n    width: 100% !important;\n    min-width: auto !important;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
